import { inject, observer } from 'mobx-preact'
import React, { Component } from 'react'
import { getSearch } from 'util'
import i18n from 'util/i18n'
import { Intro } from './Base'

@inject('store')
@observer
export default class Regist extends Component {
  componentDidMount() {
    let { back } = getSearch()
    if (back) {
      window.location.href = back
    }
  }
  render() {
    return (
      <div id="regist">
        <Intro>
          {i18n('verify-send')}
        </Intro>
      </div>
    )
  }
}
